export const FACTOR_QUERY_PARAM = 'factor'
export const SUBFACTOR_QUERY_PARAM = 'subfactor'
export const TIME_FRAME_QUERY_PARAM = 'time-frame'
export const GEOGRAPHY_QUERY_PARAM = 'geography'
export const MAX_SIDEBAR_COMPANIES = 25
